import React, { useRef } from "react"
import { Appearance, TextInput, ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { Text } from "../text/text"
import { TxKeyPath, translate } from "../../i18n"
import { DateTimePickerField } from "../field/date-time-picker-field/date-time-picker-field"
import { NumeralField } from "../field/numeral-field/numeral-field"
import { Formik } from "formik"
import * as yup from "yup"
import { FormProps } from "../form/form"
import { View } from "native-base"
import { JalaIcon } from "../jala-icon/jala-icon"
import { InfoModal } from "../auto-feeder-setup-normal-form/auto-feeder-setup-normal-form"
import { color } from "../../theme"

const FORM_CONTROL_NO_PADDING: ViewStyle = {
  paddingHorizontal: 0,
  // marginBottom: 8,
  paddingBottom: 8,
  backgroundColor: color.palette.white
}

export interface AutoFeederSetupContinueFormProps extends FormProps {
  colorScheme?: "light" | "dark",
  initialValues?: {
    debit?: number,
    onTime?: number,
    startTime?: string,
    endTime?: string,
    timesPerDay?: number,
    intervalPeriod?: number,
  },
}

/**
 * Describe your component here
 */
export const AutoFeederSetupContinueForm = observer(function AutoFeederSetupContinueForm(props: AutoFeederSetupContinueFormProps) {
  const { initialValues = {}, colorScheme = "light" || Appearance.getColorScheme(), onSubmit, innerRef, ...rest  } = props

  const input = {
    // debit: useRef<TextInput>(),
    onTime: useRef<TextInput>(),
  }

  const nextInput = {
    debit: () => input.onTime.current && input.onTime.current.focus(),
  }

  const validationSchema = yup.object({
    // debit: yup.number().nullable().required().label(translate("autoFeederPondCreateWizardScreen.debit")),
    onTime: yup.number().nullable().required().label(translate("autoFeederPondCreateWizardScreen.onTime")),
  })

  const unitElement = (type) => <View pr="8px">
    <Text text={translate(`autoFeederPondCreateWizardScreen.${type}Unit` as TxKeyPath)} preset="title4" />
  </View>

const labelComponentWithInfo = () => (
  <InfoModal>
    <View flexDirection="row" alignItems="center">
      <Text tx="autoFeederPondCreateWizardScreen.onTime" preset="title4" colorScheme={colorScheme} mr="6px" />
      <JalaIcon name="info-1" size={16} color={color.palette.gray800} />
    </View>
  </InfoModal>
)

  return (
    <Formik
      initialValues={{ ...initialValues }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
    {() => (
      <>
        {/* <NumeralField
          name="debit"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('debit') }
          }}
        /> */}
        <NumeralField
          name="onTime"
          txPrefix="autoFeederPondCreateWizardScreen"
          colorScheme={colorScheme}
          input={input}
          nextInput={nextInput}
          formControlProps={{
            labelComponent: labelComponentWithInfo(),
            style: { paddingHorizontal: 0 },
            inputProps: { placeholder: '-', InputRightElement: unitElement('onTime') },
            helperText: translate("autoFeederPondCreateWizardScreen.onHelper")
          }}
        />
        <View flexDirection="row" justifyContent="space-between">
          <DateTimePickerField
            name="startTime"
            txPrefix="autoFeederPondCreateWizardScreen"
            colorScheme={colorScheme}
            formControlProps={{ flex: 1, style: FORM_CONTROL_NO_PADDING }}
            dateTimePickerProps={{ dateTimePickerProps: { mode: "time" } }}
          />
          <View width="16px"/>
          <DateTimePickerField
            name="endTime"
            txPrefix="autoFeederPondCreateWizardScreen"
            colorScheme={colorScheme}
            formControlProps={{ flex: 1, style: FORM_CONTROL_NO_PADDING }}
            dateTimePickerProps={{ dateTimePickerProps: { mode: "time" } }}
          />
        </View>
      </>
    )}
    </Formik>
  )
})
